import { cn } from "@/shared/lib/utils";
import { Label } from "@/shared/components/ui/label";
import { Input } from "@/shared/components/ui/input";
import { InputErrorMessages } from "@/shared/components/errors/input-error-messages";

interface NumberInputProps {
  label: string;
  field: string;
  number: number;
  onNumberChange: (number: number) => void;
  min?: number;
  max?: number;
  errors: string[] | null;
  hint?: string;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

/**
 * @deprecated Use one of the options in {@link ../field/input-field.tsx}
 */
export function NumberInput({
  label,
  field,
  number,
  onNumberChange,
  min,
  max,
  errors,
  hint,
  placeholder,
  disabled,
  className,
}: NumberInputProps) {
  return (
    <div className={cn("grid content-start gap-1.5", className)}>
      <Label htmlFor={field}>{label}</Label>
      <Input
        id={field}
        type="number"
        value={number}
        min={min}
        max={max}
        onChange={(e) => onNumberChange(Number(e.target.value))}
        className={
          errors && errors.length > 0 ? "border-red-500 shadow-md" : ""
        }
        placeholder={placeholder}
        disabled={disabled}
      />
      <span className="text-muted-foreground text-sm" hidden={!hint}>
        {hint}
      </span>
      <InputErrorMessages errors={errors ?? []} />
    </div>
  );
}
